import Form from 'components/Form/Form';
import { urls } from 'config/urls';
import { LeadPayload } from 'interfaces/form.interface';
import React, { useState } from 'react';

const LEADS_URL = `${urls.API_HOST_URL}/leads`;
const LEAD_SOURCE = 'waterclock-request-data';

const FormContainer = ({ handleToggleState }: any) => {
  const [status, setStatus] = useState('');

  const handleSubmit = async (payload: LeadPayload) => {
    setStatus('sending');
    try {
      const response = await fetch(LEADS_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          source: LEAD_SOURCE,
          recaptchaToken: payload.recaptchaToken,
          honeypot: payload.honeypot,
          elapsedMs: payload.elapsedMs,
          data: {
            firstName: payload.firstName,
            lastName: payload.lastName,
            companyName: payload.companyName,
            companyEmail: payload.companyEmail,
            message: payload.message,
            joinMailingList: payload.joinMailingList,
          },
        }),
      });
      setStatus(response.ok ? 'success' : 'error');
    } catch {
      setStatus('error');
    }
  };

  return (
    <Form
      onValidated={handleSubmit}
      status={status}
      handleToggleState={handleToggleState}
    />
  );
};

export default FormContainer;
